import setPref from '@/redux/actions/uiActions/setPref.js';

const openOauthWindow = ({ appSlug, credentialId, companyId, admin = false, debugMode = false, draft, onClose }) => {
  const w = 600;
  const h = 800;
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const paramsMap = {};
  if (credentialId && String(credentialId) !== 'undefined') {
    paramsMap.credentialId = credentialId;
  }
  if (companyId) {
    paramsMap.companyId = companyId;
  }
  if (admin) {
    paramsMap.admin = true;
  }
  if (debugMode) {
    paramsMap.debug = true;
  }
  if (draft) {
    paramsMap.draft = true;
  }
  const params = new URLSearchParams(paramsMap).toString();
  const features = `
      toolbar=no,
      location=no,
      status=no,
      menubar=no,
      scrollbars=yes,
      resizable=yes,
      left=${left},
      top=${top},
      width=${w},
      height=${h}`;

  const oauthWindow = window.open(`/oauth/${appSlug}?${params}`, `gravityOauth:${appSlug}`, features);

  let consecutiveClosed = 0;
  const poll = setInterval(() => {
    try {
      if (oauthWindow?.closed !== true) {
        consecutiveClosed = 0;
        return;
      }
      consecutiveClosed += 1;
      if (consecutiveClosed < 6) {
        return;
      }
      clearInterval(poll);
      if (typeof onClose === 'function') {
        onClose();
      }
      setPref('platformLoading', { isLoading: false });
    } catch {
      consecutiveClosed = 0;
    }
  }, 500);

  return oauthWindow;
};

export default openOauthWindow;
